import request from "../request";

export const getCart = ({eventId, subEventId}) => {
	return request({
		url: `/subscription-cart/get-cart/${eventId}/${subEventId}`,
		needOverlay: false,
	});
};

/**
 * Добавление в корзину
 * @return {Promise}
 */
export const addToCart = ({eventId, subEventId, sid}) => {
	return request({
		url: `/subscription-cart/add-to-cart/${eventId}/${subEventId}`,
		data: {
			sid,
		},
	});
};

/**
 * Удаление из корзины
 * @return {Promise}
 */
export const removeFromCart = ({eventId, subEventId, sid}) => {
	return request({
		url: `/subscription-cart/remove-from-cart/${eventId}/${subEventId}`,
		data: {
			sid,
		},
	});
};

/**
 * @return {Promise}
 */
export const addAllEvents = ({eventId}) => {
	return request({
		url: `/subscription-cart/add-events/${eventId}`,
	});
};

/**
 * @return {Promise}
 */
export const removeAllEvents = ({eventId}) => {
	return request({
		url: `/subscription-cart/remove-events/${eventId}`,
	});
};

export const addEvent = ({eventId, subEventId}) => {
	return request({
		url: `/subscription-cart/add-event/${eventId}/${subEventId}`,
	});
};

export const removeEvent = ({eventId, subEventId}) => {
	return request({
		url: `/subscription-cart/remove-event/${eventId}/${subEventId}`,
	});
};

export const removeEventSids = ({eventId, subEventId}) => {
	return request({
		url: `/subscription-cart/remove-event-sids/${eventId}/${subEventId}`,
	});
};

export const moveEventCarts = ({eventId, subEventId}) => {
	return request({
		url: `/subscription-cart/move-event-carts/${eventId}/${subEventId}`,
	});
};

export const getSubscriptionChange = ({eventId, name}) => {
	return request({
		url: `/subscription/change/`,
		type: "GET",
		data: {
			event_id: eventId,
			name,
		},
	});
};
